import styled from 'styled-components';
import { Link } from 'react-router-dom';
import logoPreview from '../../assets/logo_preview.png';
import formatDate from '../../utils/formatDate';

const ImageListItem = ({ item, order }) => {
  return (
    <ItemWrapper>
      <ThumbLink to={order + item.id}>
        <PhotoThumb
          $hasImage={!!item.thumb_files}
          $imageUrl={item.thumb_files}
        />
        <PhotoTitle>{item.title}</PhotoTitle>
        <PhotoMeta>
          <span>등록일 {formatDate(item.createdAt)}</span>
          <span>조회수 {item.hit}</span>
        </PhotoMeta>
      </ThumbLink>
    </ItemWrapper>
  );
};

export default ImageListItem;

/* styles */
const ItemWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  color: #333333;
  border-bottom: 1px solid #c8c8c8;
  box-sizing: border-box;

  @media (max-width: 767px) {
    padding-bottom: 5%;
  }
`;

const ThumbLink = styled(Link)`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: #333333;
`;

const PhotoThumb = styled.div`
  width: 100%;
  aspect-ratio: 4/3;
  margin: 10px auto;
  flex-shrink: 0;
  background: ${(p) =>
    p.$hasImage
      ? `#f4f4f4 url('${p.$imageUrl}') center center no-repeat`
      : `#f4f4f4 url(${logoPreview}) 50% 50% no-repeat`};
  background-size: ${(p) => (p.$hasImage ? 'cover' : '80% 70%')};
  border-radius: 4px;

  @media (max-width: 767px) {
    width: 100%;
    height: 0;
    padding-top: 75%;
    margin-top: 30px;
    margin-bottom: 15px;
    background-size: ${(p) => (p.$hasImage ? 'cover' : '80% 70%')};
  }
`;

const PhotoTitle = styled.p`
  font-size: 16px;
  font-family: 'koPubWorld DotumB';

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  flex-shrink: 0;
  text-align: left;

  @media (max-width: 767px) {
    font-size: 17px;
  }
  @media (max-width: 375px) {
    font-size: 16px;
  }
  @media (max-width: 320px) {
    font-size: 14px;
  }
`;

const PhotoMeta = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 14px;
  font-family: 'koPubWorld DotumM';
  color: #666666;
  margin: 5px 0;
  flex-shrink: 0;
  justify-content: space-between;
  gap: 10px;

  @media (max-width: 767px) {
    justify-content: space-between;
    font-size: 12px;

    span {
      margin: 0;
      flex: 0 0 auto;

      &:last-child {
        text-align: right;
      }
    }
  }
`;
